<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 历史数据
        </span>
        <div class="normalNav zaddBtn" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <!-- <button class="OrangeSmBtn" @click="$refs.testDialog.toAddNew()">添加</button> -->
        </div>
        <div class="searchForm1 historForm">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="开始时间" prop="beginTime">
                <el-date-picker v-model="formData.beginTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="选择开始时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker v-model="formData.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" placeholder="选择结束时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="应用">
                <el-select placeholder="请选择应用" v-model="formData.appId" @change="bindChange">
                  <el-option v-for="item in applyArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="设备类型">
                <el-select placeholder="请选择设备类型" v-model="formData.typeId" @change="bindType">
                  <el-option v-for="item in deviceTypeArr" :key="item.id" :label="item.typeName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="数据流">
                <el-input v-model="formData.dataFlag" @focus="deviceFocus"></el-input>
              </el-form-item>
              <el-form-item label="区域选择">
                <el-input placeholder="请选择区域" v-model="formData.areaName" @focus="changeAreaMode"></el-input>
              </el-form-item>
              <el-form-item label="设备名称">
                <el-input placeholder="请输入设备名称" v-model="formData.deviceName"></el-input>
              </el-form-item>
              <!-- <el-form-item label="设备编码">
                <el-input v-model="formData.deviceId"></el-input>
              </el-form-item> -->
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <easyTable apiUrl="taos/taosdata/query_super" :parent="self" :config="config" :other="other" ref="table_jsgl">
            <template slot="last">
              <!-- <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">

                </template>
              </el-table-column> -->
            </template>
          </easyTable>
        </div>
      </el-tab-pane>
    </el-tabs>
    <mountPoint :hasChildNodes="areaTreeMode" :dialogVisible="areaTreeVisible" @regionTreeClose="areaTreeVisible=false" @regionTreeData="selRegionData"></mountPoint>
    <el-dialog class="editDialog dataTj" title="选择数据流" :visible.sync="editDialogVisible" width="40%">
      <el-table :data="tableData" style="width: 100%" class="stripeTable" max-height='500px' @selection-change="checkSelect" ref="Table">
        <el-table-column label="名称" prop="name">
        </el-table-column>
        <el-table-column type="selection" width="55">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
        <el-button class="confirmButton" type="primary" @click="confirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      items: [],
      formData: {
        beginTime: "",
        endTime: "",
        appId: "",
        typeId: "",
        deviceName: "",
        areaName: "",
        areaId: "",
        dataflowFlag: "",
        dataflowName: "",
        deviceId: "",
      },
      valueFormat: "yyyy-MM-dd ",
      form_jsgl: {},
      applyArr: [],
      deviceTypeArr: [],
      treeData: [],
      //区域树是否显示
      areaTreeVisible: false,
      //区域树模式选择
      areaTreeMode: true,
      editDialogVisible: false,
      tableData: [],
      configArr: [
        {
          prop: "name",
          label: "名称",
        },
      ],
      changeDevice: [],
      key: "",
      title: "",
      tabName: "jsgl",
      showTable: true,
      other: {},
      planArr: [],
      testData: [],
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        // {
        //   prop: "appName",
        //   label: "应用名称",
        // },
        // {
        //   prop: "typeName",
        //   label: "设备类型",
        // },
        {
          prop: "deviceName",
          label: "设备名称",
        },
        // {
        //   prop: "deviceAreaname",
        //   label: "设备所在位置",
        // },
        {
          prop: "dataflowName",
          label: "数据流名称",
        },
        {
          prop: "dataflowData",
          label: "数据流值",
        },
        {
          prop: "dataflowUnit",
          label: "数据单位",
        },
        {
          prop: "createTime",
          label: "上报时间",
        },
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    },
  },
  components: {
    easyTable: () => import("public/easyTable"),
    searchForm: () => import("public/searchForm"),
    mountPoint: () => import("public/mountPoint"),
  },
  mounted() {
    this.getApply();
    this.getTree();
  },
  methods: {
    getApply() {
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId?compayId=".concat(
          localStorage.getItem("companyId")
        )
      ).then(res => {
        this.applyArr = res.data.data;
      });
    },
    bindChange() {
      this.formData.deviceId = "";
      if (this.formData.appId != "") {
        this.$axiosget(
          "manager/operatingSystemApi/getDeviceTypeByOperatingId?id=".concat(
            this.formData.appId
          )
        ).then(res => {
          this.deviceTypeArr = res.data.data;
          this.formData.typeId = "";
          this.formData.dataflowFlag = "";
          this.formData.dataflowName = "";
        });
      }
    },
    // 获取数据流
    bindType() {
      if (this.formData.typeId != "") {
        this.$axiosget(
          "manager/dataFlow/queryAll?pageNum=1&pageSize=10000&device_type_id=".concat(
            this.formData.typeId
          )
        ).then(res => {
          this.tableData = res.data.data.list;
          this.formData.dataflowFlag = "";
          this.formData.dataflowName = "";
        });
      }
    },
    getTree() {
      this.$axiosget(
        "operation/area/selectByUserId?userId=".concat(
          this.$store.state.user.id
        )
      ).then(res => {
        this.treeData = res.data.data;
      });
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      this.areaTreeMode = true;
      this.areaMode = mode;
    },
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      this.formData.areaId = a.id;
      this.formData.areaName = a.name;
    },
    checkSelect(data) {
      if (data.length > 1) {
        this.$refs.Table.clearSelection();
        this.$refs.Table.toggleRowSelection(data.pop());
      } else if (data.length == 1) {
        this.changeDevice = data[0];
        // this.formData.dataflowFlag = data[0].data_flag;
        // this.formData.dataflowName = data[0].name;
        this.formData.dataFlag = data[0].name;

      }
    },
    deviceFocus() {
      if (this.formData.typeId == "") {
        this.$message.error("请选择设备类型");
      } else {
        this.editDialogVisible = true;
      }
    },
    confirm() {
      if (this.changeDevice.length < 1) {
        this.$message.error("请选择设备类型");
      } else {
        this.formData.dataflowFlag = this.changeDevice.data_flag;
        this.formData.dataflowName = this.changeDevice.name;
        this.editDialogVisible = false;
      }
    },
    reset() {
      this.formData = {
        beginTime: "",
        endTime: "",
        appId: "",
        typeId: "",
        deviceName: "",
        areaName: "",
        areaId: "",
        dataflowFlag: "",
        deviceId: "",
        dataflowName: "",
      };
      this.deviceTypeArr = [];
    },
    subSeefrom() {
      this.other = this.formData;
      this.$nextTick(this.$refs.table_jsgl.getData);
    },
  },
};
</script>
<style lang='less'>
.dataTj .el-checkbox__inner {
  background-color: #5889e4;
  border: 1px solid #5889e4;
}
.dataTj {
  thead .el-table-column--selection .cell {
    display: none;
  }
}
.historForm .el-form .el-form-item .el-form-item__content {
  width: calc(100% - 100px);
  .el-date-editor {
    width: calc(100%);
  }
  .el-range-input {
    background: #2e3657;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute4/dataAnalysis/deviceData/historicalData.vue